import React from "react";

const DownOutlined = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.34961 5.76884C3.34961 5.94975 3.40683 6.13065 3.57851 6.25126L7.87035 10.7739C8.15648 11.0754 8.55705 11.0754 8.84317 10.7739L13.135 6.25126C13.4211 5.94975 13.4211 5.52764 13.135 5.22613C12.8489 4.92462 12.4483 4.92462 12.1622 5.22613L8.32815 9.32663L4.4941 5.28643C4.20798 4.98493 3.80741 4.98493 3.52128 5.28643C3.40683 5.40704 3.34961 5.58794 3.34961 5.76884Z" fill="#5C5F64"/>
    </svg>
  );
};

export default DownOutlined;
